import { memo, type MouseEvent } from 'react'
import { X } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { isMac } from '@shared/utils/platform'
import { Button, Tooltip, useCellContext } from '@highlight/ui'

interface SidepanelCellCloseProps {
  onClick?: (e: MouseEvent) => void
  loading?: boolean
  className?: string
  showHotkey?: boolean
}

const SidepanelCellClose = memo(function SidepanelCellClose({
  onClick,
  loading,
  className,
  showHotkey = true,
}: SidepanelCellCloseProps) {
  const { size } = useCellContext()
  const position = size === 'compact' ? '-left-1.5 -top-1.5' : '-left-[9px] -top-[9px]'

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button
            data-cell-close
            aria-label="Archive"
            variant="secondary"
            size="xs"
            shape="circle"
            loading={loading}
            onClick={(e) => {
              e.stopPropagation()
              if (!loading) {
                onClick?.(e)
              }
            }}
            className={twMerge(
              'absolute z-10 opacity-0 group-hover/cell:opacity-100',
              position,
              'shadow-sm',
              'after:absolute after:inset-0 after:-m-2 after:rounded-full after:content-[""]',
              className,
            )}
          >
            <X />
          </Button>
        }
      />
      <Tooltip.Content>
        Archive
        <Tooltip.Hotkey hotkey={isMac ? 'cmd+D' : 'Del'} />
      </Tooltip.Content>
    </Tooltip>
  )
})

export { SidepanelCellClose }
